(function () {
  var track = document.getElementById('cozy-header-marque-track');
  if (!track) return;

  var slides = Array.prototype.slice.call(track.querySelectorAll('.cozy-header--marque--slide'));
  if (slides.length < 2) return;

  var delay = (parseInt(track.dataset.autoplaySpeed, 10) || 4) * 1000;
  var current = 0;
  var timer = null;
  var isPaused = false;

  function show(index) {
    if (index === current) return;
    var prev = slides[current];

    slides.forEach(function (slide) {
      slide.classList.remove('is-leaving');
    });

    prev.classList.remove('is-active');
    prev.classList.add('is-leaving');
    slides[index].classList.add('is-active');

    slides.forEach(function (slide, i) {
      var isActive = i === index;
      if (isActive) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
      var link = slide.querySelector('a');
      if (link) {
        if (isActive) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      }
    });

    current = index;
  }

  function next() {
    show((current + 1) % slides.length);
  }

  function stop() {
    clearInterval(timer);
    timer = null;
  }

  function start() {
    stop();
    if (isPaused || document.hidden) return;
    timer = setInterval(next, delay);
  }

  function pause() {
    isPaused = true;
    stop();
  }

  function resume() {
    isPaused = false;
    start();
  }

  track.addEventListener('mouseenter', pause);
  track.addEventListener('mouseleave', resume);
  track.addEventListener('focusin', pause);
  track.addEventListener('focusout', resume);
  document.addEventListener('visibilitychange', start);

  // Theme editor: show the selected block and hold it while it is selected
  document.addEventListener('shopify:block:select', function (event) {
    var index = slides.findIndex(function (slide) {
      return slide.dataset.blockId === event.detail.blockId;
    });
    if (index === -1) return;
    show(index);
    pause();
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var isOwnBlock = slides.some(function (slide) {
      return slide.dataset.blockId === event.detail.blockId;
    });
    if (isOwnBlock) resume();
  });

  start();
})();

(function () {
  var burger = document.querySelector('.cozy-header--burger');
  var header = document.querySelector('.cozy-header');
  if (!burger || !header) return;

  function syncHeaderHeight() {
    document.documentElement.style.setProperty('--cozy-header-height', header.offsetHeight + 'px');
  }
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);

  burger.addEventListener('click', function () {
    var isOpen = header.classList.toggle('nav-open');
    burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  var navLinks = header.querySelectorAll('.cozy-header--nav--link');
  navLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      header.classList.remove('nav-open');
      burger.setAttribute('aria-expanded', 'false');
    });
  });
})();
